import { styled } from '@mui/material/styles'
import { colors, typography, radius, focusVisible } from '@/styles/designTokens'

interface CheckoutButtonRootProps {
	isDisabled: boolean
	isLoading: boolean
}

export const CheckoutButtonRoot = styled('button', {
	shouldForwardProp: (prop) => prop !== 'isDisabled' && prop !== 'isLoading',
})<CheckoutButtonRootProps>(({ isDisabled, isLoading }) => ({
	width: '100%',
	height: 40,
	borderRadius: radius.pill,
	border: 'none',
	backgroundColor: colors.brand,
	color: colors.textInverse,
	fontSize: typography.fontSizeMd,
	fontWeight: typography.fontWeightBold,
	lineHeight: typography.lineHeightLg,
	letterSpacing: typography.letterSpacingWide,
	fontFamily: 'inherit',
	textTransform: 'uppercase',
	cursor: isDisabled || isLoading ? 'not-allowed' : 'pointer',
	opacity: isDisabled ? 0.5 : 1,
	display: 'flex',
	alignItems: 'center',
	justifyContent: 'center',
	gap: 8,
	fontVariantNumeric: 'tabular-nums',
	transition: 'opacity 0.15s',
	'&:focus-visible': {
		outline: `${focusVisible.outline} ${colors.brand}`,
		outlineOffset: focusVisible.outlineOffset,
	},
}))
